// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contributorsViewWrapper":"ContributorsView__contributorsViewWrapper___gSZZX","contributorsView":"ContributorsView__contributorsView___3cA7h"};
    if(module.hot) {
      // 1778083499703
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  